module.exports = __webpack_public_path__ + "img/vaf.3c3990de.webp";